import * as signalR from '@microsoft/signalr';
import type { ListChatGroupDto, ListChatMessageByGroupDto, ChatGroupDetailDto } from "~/core/services/ApiClient";

// Interface cho notification data
export interface NotificationData {
  id: number;
  title: string;
  message: string;
  url?: string;
  appId?: number;
  objectType?: string;
  objectId?: number;
  createdDate: string;
  isRead: boolean;
}

// Interface cho payment notification data
export interface PaymentNotificationData {
  receipts: any[]; // ReceiptEntity[]
  message?: string;
}

export class SignalRService {
  private static connection: signalR.HubConnection
    
  static startConnection(token: string) {
    if (!this.connection) {
      const config = useRuntimeConfig();
      this.connection = new signalR.HubConnectionBuilder()
          .withUrl(config.public.systemHubUrl, {
          accessTokenFactory: () => token
        })
        .build()

      this.connection.start()
        .then(() => console.log('Connected to SignalR Server'))
        .catch((err) => console.error('Error connecting to SignalR: ', err))
    }
  }

  static sendMessage(data: object) {
    if (this.connection) {
      this.connection.send('SendMessageToGroup', data);
      console.log('ggửi mess', data);
    }
  }

  static onReceiveMessage(callback: (data: object) => void) {
    if (this.connection) {
      this.connection.on('ReceiveMessage', callback);
    }
  }

  static onReceiveNotification(callback: (notification: NotificationData) => void) {
    if (this.connection) {
      this.connection.on('ReceiveNotification', callback);
    }
  }

  static offReceiveNotification() {
    if (this.connection) {
      this.connection.off('ReceiveNotification');
    }
  }

  static onReceivePaymentNotification(callback: (data: PaymentNotificationData) => void) {
    if (this.connection) {
      this.connection.on('ReceivePaymentNotification', callback);
    }
  }

  static offReceivePaymentNotification() {
    if (this.connection) {
      this.connection.off('ReceivePaymentNotification');
    }
  }
  
  static onUserOnline(callback: (data: number) => void) {
    if (this.connection) {
      this.connection.on('UserOnline', callback);
    }
  }

  static onUserOffline(callback: (data: number) => void) {
    if (this.connection) {
      this.connection.on('UserOffline', callback);
    }
  }

  static getConnectionStatus(): signalR.HubConnectionState | undefined {
    return this.connection?.state;
  }

  static async stopConnection() {
    if (this.connection) {
      await this.connection.stop();
    }
  }
}